import Vue from 'vue';
import Swiper, { Scrollbar, Navigation } from 'swiper';

Vue.component('players-slider-component', {

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            swiper: null,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.initSwiper();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        initSwiper() {
            this.swiper = new Swiper('.players-slider', {
                modules: [Scrollbar, Navigation],
                slidesPerView: 'auto',
                spaceBetween: 20,
                grabCursor: true,
                scrollbar: {
                    el: '.image-carousel__scrollbar',
                    draggable: true,
                },
                navigation: {
                    prevEl: '.image-carousel__navigation-prev',
                    nextEl: '.image-carousel__navigation-next',
                },
                preventClicks: true,
                // fix for the scrollbar
                on: {
                    init(swiper) {
                        swiper.update();
                    },
                },
            });
        },

    },

    beforeDestroy() {
    },
});
